import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acceptable-upload',
  templateUrl: './acceptable-upload.component.html',
  styleUrls: ['./acceptable-upload.component.scss']
})
export class AcceptableUploadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
